const errorMessageId = ({ prefix, id }) => `${prefix}-errorMessage-${id}`;
export default {
    errorMessageId,
};
//# sourceMappingURL=index.js.map